import React, { FC } from 'react'
import cn from 'classnames'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { Button, ButtonGroup, DialogBase } from 'ui'
import styles from '@styles/components/FireflyToSDialog.module.scss'
import { useFireflyActions, useFireflyState } from '@hooks/useFirefly'
import {
  LocalStorageBooleanValue,
  LocalStorageKey
} from 'constants/localStorage'
import { useMediumMinimumSizePreference } from '@hooks/useProject'
import { useTranslations } from 'use-intl'

const FireflyToSDialog: FC = () => {
  const flags = useFlags()
  const t = useTranslations()

  const size = useMediumMinimumSizePreference()

  const showToSPopup = useFireflyState('showToSPopup')
  const { generateImages, setShowToSPopup } = useFireflyActions()

  const show = showToSPopup && flags['base-pf-ui-firefly-tos-dialog']

  function handleAgreeToS() {
    setShowToSPopup(false)
    localStorage.setItem(
      LocalStorageKey.fireflyAgreedToToS,
      LocalStorageBooleanValue.TRUE
    )
    generateImages()
  }

  return (
    <DialogBase underlay open={show}>
      <div
        className={cn(styles['dialog'], {
          [styles['no-pointer-events']]: !show
        })}
      >
        <img
          src="/firefly_tos_banner.png"
          alt={t('studio:firefly:terms:imageAlt')}
        />

        <h2>{t('studio:firefly:terms')}</h2>

        <p>{t('studio:firefly:terms:subheader')}</p>

        <p>
          {t.rich('studio:firefly:terms:text', {
            hyperlinked: chunks => (
              <a href={t('studio:firefly:terms:url')} target="_blank">
                {chunks}
              </a>
            )
          })}
        </p>

        <ButtonGroup>
          <Button
            size={size}
            treatment="outline"
            variant="secondary"
            onClick={() => setShowToSPopup(false)}
          >
            {t('studio:firefly:terms:cancel')}
          </Button>
          <Button size={size} variant="accent" onClick={handleAgreeToS}>
            {t('studio:firefly:terms:agree')}
          </Button>
        </ButtonGroup>
      </div>
    </DialogBase>
  )
}

export default FireflyToSDialog
